<div
  class="shrink-0 rounded-radius-circle flex justify-center items-center"
  [ngClass]="[
    properties()[status()].bgColorClass ?? '',
    properties()[status()].dropShadowClass ?? '',
    'w-[16px] h-[16px]',
    backgroundClasses(),
  ]"
>
  @if (properties()[status()].iconName; as iconName) {
    <svg-icon [key]="iconName" [ngClass]="properties()[status()].iconColorClass ?? ''" [size]="iconSize()"></svg-icon>
  }
</div>
@if (properties()[status()].label; as label) {
  {{ label | unwrapAsyncValue }}
}
